import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GLOBAL } from 'src/app/app.globals';
import { LogHelperService } from 'src/app/core/services/log-helper.service';
import { ApiCallService } from 'src/app/service/api-call.service';
import { EditSalaryWageMasterComponent } from '../edit-salary-wage-master/edit-salary-wage-master.component';

@Component({
  selector: 'app-salary-wage-master',
  templateUrl: './salary-wage-master.component.html',
  styleUrls: ['./salary-wage-master.component.css']
})
export class SalaryWageMasterComponent implements OnInit {

  @Input() selectedData: any;
  @Input() editRowData: any;
  @Input() editContractorData: any;

  @Input() isEditMode: boolean;
  isCeilingAmountDisabled: boolean = true;

  skillNameList: any[] = [];
  selectedItems: any[] = [];
  plantList: any[] = [];
  areaData: any[] = [];
  selectedSkillItems: any[] = [];
  selectedSkillList: any[] = [];
  selectedSkills: any[] = [];
  minimumWageList: any[] = [];

  selectedMinimumWages: any;

  selectedSkillsSet: Set<number> = new Set();
  epfCalculation: number = 0;
  ceilingAmount: number | null = null;
  selectedArea: any;
  selectedPlantMap: { [skillCode: number]: number } = {};

  skillNameMap: { [key: number]: string } = {};

  errorMessage: string = "";
  ceilingAmountDate: string = '';

  selectedPlant: any = null;
  uniqueSkillCodeArray: any;

  constructor(
    public activeModal: NgbActiveModal,
    private logHelperService: LogHelperService,
    private apiCall: ApiCallService,
    private cdr: ChangeDetectorRef,
    private modalService: NgbModal,
  ) { }


  ngOnInit() {
    const reqObj = {
      Search: null,
      Plant_Code: null,
      ParentSkill_Code: null,
      Trade_Code: null,
      Action: 0,
      RquestType: 0,
      RequestedUserID: GLOBAL.USER_ID
    };

    this.apiCall.getAllSkillMaster(reqObj).subscribe((res: any) => {
      this.skillNameList = res;
      res.forEach(skill => {
        this.skillNameMap[skill.Skill_Code] = skill.SkillName;
      });

    });

    const requestObj = {
      ShortCode: null,
      Search: null,
      Parent_Code: "1107", // Area ka Parent_Code
      Page_Code: null,
      RequireType: 2,
      ActionType: 0,
      UserId: GLOBAL.USER_ID,
    };
    
    this.apiCall.getArea(requestObj).subscribe((response) => {
      this.areaData = response;
    });

    this.getPlant();
    if (this.isEditMode) {
      this.onPlantEdit();
      this.selectedSkillsSet = new Set(this.editRowData.map(item => item.Skill_Code));
    }
  }

  getPlant(): void {
    const reqObj = {
      Search: '',
      Company: '',
      State: '',
      City: '',
      Country: '',
      UnitType: '',
      OwnerShip: '',
      LocatedAt: '',
      IsESICApplicable: '',
    };
    this.apiCall.getPlant(reqObj).subscribe((response: any) => {
      this.plantList = response;

      if (this.selectedPlant != null || this.selectedPlant != "" || this.selectedPlant != undefined) {
        let params = {
          Company_Code: this.plantList[0].Company_Code,
          Plant_Code: null,
          // Plant_Code: this.selectedPlant,
          State_Code: null,
          Action: 1, //0: All list  | 1:Active list
          RequireType: 0,
          RequestedUserId: GLOBAL.USER_ID
        }

        this.apiCall.getAllMinimumWageMasterList(params).subscribe((res: any) => {
          this.minimumWageList = res
        });
      }
    });
  }

  onPlantChange() {
    this.getPlant();
    this.selectedMinimumWages = null;
  }

  onMinimumWageChange(event: any, skills: Set<any>) {
    this.minimumWageList.forEach(items => {
      if (this.selectedMinimumWages == items.ID) {
        if (items.Plant_Code != this.selectedPlant) {
          this.selectedMinimumWages = null;
          this.logHelperService.logError({
            message: `❌ Please select a correct minimum wage.`,
          });
          return;
        }
      }
    })
    if (!skills || skills.size === 0) {
      this.selectedMinimumWages = null;
      this.logHelperService.logError({
        message: `❌ Please select at least one skill!`,
      });
      return;
    }

    if (!this.selectedArea) {
      this.logHelperService.logError({
        message: `❌ Please select area!`,
      });
      return;
    }

    if (!this.selectedPlant) {
      this.selectedMinimumWages = null;
      this.logHelperService.logError({
        message: `❌ Please select a plant before choosing minimum wage.`,
      });
      return;
    }
    console.log("✅ Minimum Wage changed to:", event);
  }

  missingSkillNames:any[] = []
  onPlantAdd(plantCode: number) {
    const reqObj = {
      Plant_Code: plantCode,
      Skill_Code: null,
      Action: 0,
      RequireType: 0,
      RequestedUserId: GLOBAL.USER_ID,
      MinWageMasterID: this.selectedMinimumWages
    };

    this.apiCall.getAllMinimumWages(reqObj).subscribe((res: any) => {
      const skillWiseTables = new Map<number, any[]>();

      const missingSkills: number[] = [];

      this.selectedSkillsSet.forEach((skillCode: number) => {
        if (!res.some(item => item.Skill_Code === skillCode)) {
          missingSkills.push(skillCode);
        }
      });

      this.missingSkillNames = missingSkills.map(skillCode => {
        const found = this.skillNameList.find(item => item.Skill_Code === skillCode);
        return found ? found.SkillName : `Skill ${skillCode}`;
      });

      if (this.missingSkillNames.length > 0) {
        this.isPlantDisabled = false
        this.logHelperService.logError({
          message: `Please unselect ${this.missingSkillNames.join(', ')} skills before adding details.`
        });
        return;
      }

      res.forEach((item: any) => {
        if (this.selectedSkillsSet.has(item.Skill_Code)) {
          if (!skillWiseTables.has(item.Skill_Code)) {
            skillWiseTables.set(item.Skill_Code, []);
          }
          skillWiseTables.get(item.Skill_Code).push(item);
        }
      });

      const newSkillEntries = Array.from(skillWiseTables.entries()).map(([skillCode, data]) => {
        let updatedSkillItems = data.map(entry => ({
          ...entry,
          setAmount: entry.Amount,
          ApplicableDateFormatted: entry.ApplicableDate ? entry.ApplicableDate.split('T')[0] : '',
          MinimumWageID: this.selectedMinimumWages,
          MinWageMasterID: this.selectedMinimumWages
        }));
      
        // Separate 114 & 115
        const Component114_115 = updatedSkillItems.filter(item =>
          item.Component_Code === 114 || item.Component_Code === 115
        );
      
        // Filter items based on selectedArea (excluding 114 & 115)
        const filteredItems = updatedSkillItems.filter(item =>
          (item.Component_Code === 114 || item.Component_Code === 115) || item.AreaMIL_Code === this.selectedArea
        );
      
        // ✅ If filteredItems only has 114 and 115 → skip this skill
        const only114_115 = filteredItems.every(item =>
          item.Component_Code === 114 || item.Component_Code === 115
        );
      
        if (only114_115) {
          return null; // 👈 Don't include this in final list
        }
      
        let IsMinWageConfigValue: any[] = [];
        let IsNonMinWageConfigValue: any[] = [];
      
        filteredItems.forEach((item) => {
          if (item.IsMinWageConfigValue == 1 && item.Component_Code !== 114 && item.Component_Code !== 115) {
            IsMinWageConfigValue.push(item);
          } else if (item.Component_Code !== 114 && item.Component_Code !== 115) {
            IsNonMinWageConfigValue.push(item);
          }
        });
      
        const totalMinWageAmount = IsMinWageConfigValue.reduce((sum, item) => sum + (item.Amount || 0), 0);
        const totalMinWageSetAmount = IsMinWageConfigValue.reduce((sum, item) => sum + (item.setAmount || 0), 0);
      
        return {
          skillCode,
          data: IsMinWageConfigValue
            .concat([{
              Component_Code: -124,
              setAmount: this.isEditMode ? totalMinWageSetAmount : totalMinWageAmount,
              Amount: totalMinWageAmount,
              ShortName: "Total Min Wage Amount",
              isReadOnly: false
            }])
            .concat(IsNonMinWageConfigValue)
            .concat(Component114_115)
        };
      })
      .filter(item => item !== null);
      
      // Append new entries to existing selectedSkillList instead of replacing
      this.selectedSkillList = this.selectedSkillList.concat(newSkillEntries);
      console.log("✅ Skill Wise Tables:", this.selectedSkillList);
      if(this.selectedSkillList.length === 0){
        this.isPlantDisabled = false;
        this.logHelperService.logError({
          message: `No data found.`
        });
        return;
      }
    });
  }

  onPlantEdit() {
    const reqObj = {
      Plant_Code: null,
      Skill_Code: null,
      Action: 0,
      RequireType: 0,
      RequestedUserId: GLOBAL.USER_ID
    };

    this.apiCall.getAllMinimumWages(reqObj).subscribe((res: any) => {
      const filteredData = res.filter(item => this.selectedSkillsSet.has(item.Skill_Code));

      // ✅ **Properly Define Type for groupedData**
      const groupedData: Record<string, { skillCode: number, minWageID: number, data: any[] }> = {};

      filteredData.forEach(item => {
        const minWageID = item.MinWageMasterID;
        const skillCode = item.Skill_Code;

        const key = `${minWageID}-${skillCode}`;

        if (!groupedData[key]) {
          groupedData[key] = { skillCode, minWageID, data: [] };
        }

        groupedData[key].data.push({
          MinWageMasterID: item.MinWageMasterID,
          Skill_Code: item.Skill_Code,
          Component_Code: item.Component_Code,
          setAmount: item.Amount,
          ShortName: item.ShortName,
          ApplicableDateFormatted: item.ApplicableDate ? item.ApplicableDate.split('T')[0] : '',
          MinimumWageID: item.MinWageMasterID,
          Amount: item.Amount,
          IsMinWageConfigValue: item.IsMinWageConfigValue
        });
      });

      this.selectedSkillList = Object.values(groupedData).map(({ skillCode, minWageID, data }) => {
        const IsMinWageConfigValue = data.filter(item => item.IsMinWageConfigValue);
        const IsNonMinWageConfigValue = data.filter(item => !item.IsMinWageConfigValue);

        const totalMinWageAmount = IsMinWageConfigValue.reduce((sum, item) => sum + (item.Amount || 0), 0);
        const totalMinWageSetAmount = IsMinWageConfigValue.reduce((sum, item) => sum + (item.setAmount || 0), 0);

        return {
          skillCode,
          minWageID,
          data: IsMinWageConfigValue
            .concat([{
              Component_Code: -124,
              setAmount: this.isEditMode ? totalMinWageSetAmount : totalMinWageAmount,
              Amount: totalMinWageAmount,
              ShortName: "Total Min Wage Amount",
              isReadOnly: false
            }])
            .concat(IsNonMinWageConfigValue)
        };
      });

      console.log('✅ this.selectedSkillList:', this.selectedSkillList);
    });
  }

  openEditSalaryWageTable(skillCode, selectedData) {
    const modalRef = this.modalService.open(EditSalaryWageMasterComponent,
      { size: 'lg', backdrop: 'static', windowClass: 'modal-scrollbar-hide' }
    );
    modalRef.componentInstance.selectedData = selectedData;
    modalRef.componentInstance.skillCode = skillCode;
    modalRef.componentInstance.editRowData = this.editRowData;
    modalRef.componentInstance.minimumWageList = this.minimumWageList;

    modalRef.componentInstance.editContractorData = this.editContractorData;
    modalRef.result.then((result) => {
      this.activeModal.close();
    })
  }

  onSkillChange(newValues: number[]) {
    const prev = Array.from(this.selectedSkillsSet);
    this.selectedSkills = newValues;
    this.selectedSkillsSet = new Set(newValues);
    
    newValues.forEach(skillCode => {
      if (prev.indexOf(skillCode) === -1 && !this.selectedPlantMap[skillCode]) {
        this.selectedPlantMap[skillCode] = null;
      }
    });
  
    prev.forEach(skillCode => {
      if (!this.selectedSkillsSet.has(skillCode)) {
        this.selectedSkillsSet.delete(skillCode);
        delete this.selectedPlantMap[skillCode];
        delete this.selectedSkillList[skillCode];
      }
    });
  }
  
  isPlantDisabled = false;
  addPlant() {
    if (!this.selectedSkillsSet || this.selectedSkillsSet.size === 0) {
      this.logHelperService.logError({
        message: `❌ Please select at least one Skill!`,
      });
      return;
    }

    if (!this.selectedPlant) {
      this.logHelperService.logError({
        message: `❌ Please select a Plant!`,
      });
      return;
    }

    if (this.selectedMinimumWages == null) {
      this.logHelperService.logError({
        message: `❌ Please select a Minimum Wage!`,
      });
      return;
    }

    // Check for duplicate entries before adding
    if (this.checkClientSideDuplicates()) {
      this.logHelperService.logError({
        message: 'Duplicate salary information already exists for selected combination. Please check and try again.'
      });
      return;
    }
    
    this.onPlantAdd(this.selectedPlant);
  }

  onDropdownChange(data) {
    const skillTable = this.selectedSkillList.find(skill => skill.skillCode === data.Skill_Code);
    if (!skillTable) return;

    const has114WithZeroAmount = skillTable.data.some(item => item.Component_Code === 114 && item.Amount == 0);

    skillTable.data.forEach(item => {
      if (item.Component_Code === 115) {
        item.isReadOnly = has114WithZeroAmount;
      }
    });
  }


  //   onMinimumWageChange(event: any, skill: any, code: any, index: number) {
  //     this.selectedMinimumWages = { ...this.selectedMinimumWages, [index]: event };

  //     let reqObj = {
  //       ContractorVendor_Code: !this.isEditMode ? this.selectedData.ContractorVendor_Code : this.editContractorData.ContractorVendor_Code,
  //       Plant_Code: skill[code][0].Plant_Code,
  //       State_Code: skill[code][0].State_Code,
  //       MiniWageCriteriaCompanyID: skill[code][0].MinWageMasterID,
  //       Action: 1,
  //       RequireType: 0,
  //       Skill_Code: code,
  //       RequestedUserId: GLOBAL.USER_ID

  //     }
  //     this.apiCall.checkMinimumWageEntry(reqObj).subscribe((res: any) => {
  //       if (res[0].Msg === "Exist") {
  //         this.logHelperService.logError({
  //           message: `Selected Minimum Wage is already exist. Please select another Minimum Wage`,
  //         });
  //         this.selectedMinimumWages = { ...this.selectedMinimumWages, [index]: null };
  //         this.cdr.detectChanges();
  //         return;
  //       }

  //       if (event != null) {
  //         this.minimumWageList.forEach(items => {
  //           if (items.ID === skill[code][0].MinWageMasterID) {
  //             this.selectedSkillList[code].forEach(result => {
  //               result.ApplicableDateFormatted = items.ApplicableDate.split('T')[0]
  //             })
  //           }
  //         })
  //       } else {
  //         this.selectedSkillList[code].forEach(result => {
  //           result.ApplicableDateFormatted = null
  //         })
  //       }
  //     });
  //   }


  onChangeAmount(data, entry, skillCode) {
    if (entry.IsMinWageConfigValue === 1) {
      let totalSetAmount = 0;

      for (let items of skillCode) {
        if (items.Component_Code === -124) {
          break;
        }
        totalSetAmount += items.setAmount ? Number(items.setAmount) : 0;
      }

      for (let items of skillCode) {
        if (items.Component_Code === -124) {
          items.setAmount = totalSetAmount;
          break;
        }
      }
    }
  }

  formatDate(dateStr: string): string {
    let dateObj = new Date(dateStr);
    let month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
    let day = dateObj.getDate().toString().padStart(2, '0');
    let year = dateObj.getFullYear();
    return `${month}/${day}/${year}`;
  }

  saveAllDataButton(): void {
    if (this.missingSkillNames.length > 0) {
      this.logHelperService.logError({
        message: `Please unselect ${this.missingSkillNames.join(', ')} skills before adding details.`
      });
      return;
    }

    this.proceedWithSave();
  }

  private checkClientSideDuplicates(): boolean {
    const currentCombination = {
      plant: this.selectedPlant,
      minimumWage: this.selectedMinimumWages,
      skills: Array.from(this.selectedSkillsSet).sort().join(',')
    };
    
    // Check if this exact combination already exists in selectedSkillList
    for (const existingSkill of this.selectedSkillList) {
      if (existingSkill.data && existingSkill.data.length > 0) {
        const existingCombination = {
          plant: existingSkill.data[0].Plant_Code,
          minimumWage: existingSkill.data[0].MinimumWageID || this.selectedMinimumWages,
          skills: existingSkill.skillCode.toString()
        };
        
        // Check if plant and minimum wage match, and if any skill overlaps
        if (existingCombination.plant === currentCombination.plant && 
            existingCombination.minimumWage === currentCombination.minimumWage) {
          
          // Check if any selected skill already exists
          for (const skillCode of this.selectedSkillsSet) {
            if (skillCode.toString() === existingCombination.skills) {
              return true; // Duplicate found
            }
          }
        }
      }
    }
    
    return false; // No duplicates found
  }

  private proceedWithSave(): void {
    const selectedEntriesMap = {};
    const uniqueKey = `AF02D3CA-051A-4892-9A17-521D1FCA373F`;
    selectedEntriesMap[uniqueKey] = [];
    let index = 0;

    for (const skillCode of this.selectedSkillsSet) {
      let skillData = this.selectedSkillList.find(item => item.skillCode === skillCode);
      if (!skillData) continue;

      let minWageEntry = skillData.data.find(entry => entry.Component_Code === -124);
      if (minWageEntry && minWageEntry.setAmount < minWageEntry.Amount) {
        this.logHelperService.logError({
          message: `Total Per Day Value (${minWageEntry.setAmount}) cannot be less than ${minWageEntry.Amount}`,
        });
        return;
      }

      for (const entry of skillData.data) {
        if (entry.Component_Code == 115 && Number(entry.Amount) < 15000) {
          this.logHelperService.logError({
            message: `Amount (${entry.Amount}) for Component EPF Ceiling Value cannot be less than 15000`,
          });
          return;
        }

        if (entry.Component_Code !== -124 && entry.IsMinWageConfigValue !== 1 && entry.Component_Code !== 114 && entry.Component_Code !== 115) {
          if (entry.setAmount < entry.Amount) {
            this.logHelperService.logError({
              message: `Amount (${entry.setAmount}) for Component Name ${entry.ShortName} cannot be less than Master Value (${entry.Amount})`,
            });
            return;
          }
        }
      }

      if (!selectedEntriesMap[uniqueKey]) {
        selectedEntriesMap[uniqueKey] = [];
      }

      skillData.data.forEach((entry) => {
        if (entry.Component_Code !== -124) {
          selectedEntriesMap[uniqueKey].push({
            ID: null,
            ContractorVendor_Code: !this.isEditMode ? this.selectedData.ContractorVendor_Code : this.editContractorData.ContractorVendor_Code,
            MinWageMasterID: entry.MinWageMasterID,
            SubContractorVendor_Code: null,
            Company_Code: entry.Company_Code,
            Plant_Code: entry.Plant_Code,
            State_Code: entry.State_Code,
            Skill_Code: entry.Skill_Code,
            AreaMIL_Code: entry.AreaMIL_Code,
            ZoneMIL_Code: entry.ZoneMIL_Code,
            QualificationMIL_Code: entry.QualificationMIL_Code,
            GradeMIL_Code: entry.GradeMIL_Code,
            GenderMIL_Code: null,
            CategoryMIL_Code: entry.CategoryMIL_Code,
            SubCategoryMIL_Code: entry.SubCategoryMIL_Code,
            Component_Code: entry.Component_Code,
            IsFoodInclude: entry.IsFoodInclude,
            PerDayValue: (function() {
              if (entry.Component_Code === 114 || entry.Component_Code === 115) {
                if (entry.Component_Code === 115 && skillData.data.some(e => e.Component_Code === 114 && e.Amount === 0)) {
                  return 0;
                }
                return entry.Amount;
              }
              return entry.setAmount ? entry.setAmount : 0;
            })(),
            ApplicableDate: this.formatDate(entry.ApplicableDate),
            CreatedBy: GLOBAL.USER_ID,
            Modifiedby: GLOBAL.USER_ID,
            IsActive: 1,
            IsDeleted: 0,
            MiniWageCriteriaCompanyID: this.selectedMinimumWages
          });
        }
      });
      index++;
    }

    this.apiCall.apiCommonInsertUpdate(selectedEntriesMap).subscribe((res: any) => {
      console.log("✅ Data saved successfully:", res);
      this.activeModal.close();
    });
  }

}